// extracted by mini-css-extract-plugin
export default {"root":"_2cHTY","left":"_1usWG","left-side-item-wrapper":"_2rdBf","leftSideItemWrapper":"_2rdBf","right":"_2h2fz","right-side-item-wrapper":"_2jqRc","rightSideItemWrapper":"_2jqRc"};